import api from "@/services/api";

export default {
  getWorkspaces() {
    return api.get("/api/v1/workspaces");
  },

  createWorkspace(workspaceData) {
    return api.post("/api/v1/workspaces", workspaceData);
  },

  getWorkspace() {
    return api.get(`/api/v1/workspace`);
  },

  updateWorkspace(workspaceData) {
    return api.put(`/api/v1/workspace`, workspaceData);
  },

  deleteWorkspace() {
    return api.delete(`/api/v1/workspace`);
  },

  getWorkspaceUsers() {
    return api.get(`/api/v1/workspaces/users`);
  },

  // Haal de uitnodigingen van een workspace op
  getInvitations() {
    return api.get(`/api/v1/workspaces/invitations`);
  },

  getUser(userId) {
    return api.get(`/api/v1/users/${userId}`);
  }
};
